import api, { handleApiError, normalizeRoleName } from './client';

export const roleService = {
  getAppRoles: async () => {
    try {
      const response = await api.get('/api/roles');
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Get app roles error:', error);
      return handleApiError(error, 'Errore nel caricamento dei ruoli');
    }
  },

  createAppRole: async (name, label) => {
    try {
      const response = await api.post('/api/roles', {
        name: normalizeRoleName(name),
        label: label.trim(),
      });
      return { success: true, data: response.data, message: 'Ruolo creato con successo' };
    } catch (error) {
      console.error('Create app role error:', error);
      return handleApiError(error, 'Errore nella creazione del ruolo');
    }
  },

  updateAppRole: async (id, name, label) => {
    try {
      const response = await api.put(`/api/roles/${id}`, {
        id,
        name: normalizeRoleName(name),
        label: label.trim(),
      });
      return { success: true, data: response.data, message: 'Ruolo aggiornato con successo' };
    } catch (error) {
      console.error('Update app role error:', error);
      return handleApiError(error, "Errore nell'aggiornamento del ruolo");
    }
  },

  deleteAppRole: async (id) => {
    try {
      await api.delete(`/api/roles/${id}`);
      return { success: true, message: 'Ruolo eliminato con successo' };
    } catch (error) {
      console.error('Delete app role error:', error);
      return handleApiError(error, "Errore nell'eliminazione del ruolo");
    }
  },
};

export default roleService;
